import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core';

import { AtatusErrorHandler } from './atatus.handler';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { environment } from '../environments/environment';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { TokenInterceptor } from './http.interceptor';

import { HttpErrorDialogComponent } from "./http-error-dialog.component";
import { SlickDialogModule } from "slick-components";
import { HttpService, GlobalsService } from "@services";

import { HashLocationStrategy, LocationStrategy } from '@angular/common';

// Layout

@NgModule({
	declarations: [
		AppComponent,
		HttpErrorDialogComponent
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		HttpClientModule,
		SlickDialogModule
	],
	providers: [
		HttpService,
		GlobalsService,
		{
			provide: LocationStrategy,
			useClass: HashLocationStrategy
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: TokenInterceptor,
			multi: true
		},
		{
			provide: ErrorHandler,
			useClass: AtatusErrorHandler
		},
		{
			provide: APP_INITIALIZER, useFactory: init, deps: [GlobalsService],
			multi: true
		},

	],
	bootstrap: [AppComponent]
})
export class AppModule { }

export function init(globalsService: GlobalsService) {
	return async () => {
		if (!environment.production)
			globalsService.setDebug();
	}
}

